import { useQuery } from '@apollo/client';

import { UserPermission, UserRole } from './user.model';
import { MeQuery, MeQueryResult } from './user.queries';

export const useHasPermission = (userPermission: UserPermission) => {
  const { data: myUserData } = useQuery<MeQueryResult>(MeQuery);
  const userPermissions = myUserData?.me?.permissions;

  if (userPermissions) {
    return userPermissions.includes(userPermission);
  }

  return null;
};

export const useHasRole = (roles: UserRole[]) => {
  const { data: myUserData } = useQuery<MeQueryResult>(MeQuery);
  const userRole = myUserData?.me?.role;

  if (userRole) {
    return roles.includes(userRole);
  }

  return null;
};

export const useIsAuthenticated = () =>
  !!useQuery<MeQueryResult>(MeQuery).data?.me;
